export default function isSafeClassName(className) {
  return className.indexOf('ad') === -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela/es/isSafeClassName.js
// module id = 1138
// module chunks = 0